"use client";

import React from 'react';
import Image from 'next/image';

import { useLocale } from "@/context/LocaleContext";

export default function CustomRSVPFeature() {
  const { t } = useLocale(); 

  return (
    <div className="w-full">
      <section className="w-full bg-gray-50 py-16 md:py-24 -mt-11">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-20">
            <div className="w-full md:w-[45%] flex justify-center">
              <div className="relative w-full max-w-[400px] aspect-[4/3] md:aspect-square">
                <Image 
                  src="/images/features/landing-page/calendar-cr.webp" 
                  alt="Status kehadiran yang jelas" 
                  fill 
                  className="object-contain drop-shadow-xl" 
                />
              </div>
            </div>

            {/* Teks */}
            <div className="w-full md:w-[55%]">
              <h2 className="text-2xl md:text-3xl lg:text-[2.2rem] font-extrabold text-gray-900 mb-6 leading-tight tracking-tight">
                {t("CustomRSVP.section1_title") || "Status kehadiran yang jelas"}
              </h2>
              <p className="text-gray-700 text-[15px] md:text-[17px] leading-relaxed mb-4">
                {t("CustomRSVP.section1_desc") || "Setiap tamu akan tercatat dengan status kehadiran yang jelas, sehingga kamu bisa:"}
              </p>
              <ul className="list-disc pl-5 space-y-2.5 text-gray-700 text-[15px] md:text-[17px]">
                <li>{t("CustomRSVP.section1_li_1") || "Mengetahui jumlah tamu yang akan hadir"}</li>
                <li>{t("CustomRSVP.section1_li_2") || "Memantau respon tamu secara realtime"}</li>
                <li>{t("CustomRSVP.section1_li_3") || "Mengurangi kebingungan jelang hari acara"}</li>
              </ul>
            </div>

          </div>
        </div>
      </section>

      <section className="w-full bg-white py-16 md:py-24 border-y border-gray-100">
        <div className="max-w-6xl mx-auto px-4 md:px-8">
          <div className="flex flex-col md:flex-row-reverse items-center gap-12 lg:gap-20">
            <div className="w-full md:w-[45%] flex justify-center">
              <div className="relative w-full max-w-[370px] aspect-[4/3] md:aspect-square">
                <Image 
                  src="/images/features/landing-page/limit-group.webp" 
                  alt="Batas jumlah tamu per undangan" 
                  fill 
                  className="object-contain drop-shadow-xl" 
                />
              </div>
            </div>

            {/* Teks */}
            <div className="w-full md:w-[55%]">
              <h2 className="text-2xl md:text-3xl lg:text-[2.2rem] font-extrabold text-gray-900 mb-6 leading-tight tracking-tight">
                {t("CustomRSVP.section2_title") || "Batas jumlah tamu per undangan"}
              </h2>
              <p 
                className="text-gray-700 text-[15px] md:text-[17px] leading-relaxed mb-4"
                dangerouslySetInnerHTML={{ __html: t("CustomRSVP.section2_desc") || "Dengan fitur ini, kamu dapat <b>menentukan berapa maksimal orang yang boleh dibawa oleh setiap tamu.</b><br/><span class='mt-2 block font-medium'>Contohnya:</span>" }}
              />
              <ul className="list-disc pl-5 space-y-2.5 text-gray-700 text-[15px] md:text-[17px] mb-5">
                <li>{t("CustomRSVP.section2_li_1") || "Undangan pribadi: maksimal 1-2 orang"}</li>
                <li>{t("CustomRSVP.section2_li_2") || "Undangan keluarga: maksimal sesuai kuota"}</li>
                <li>{t("CustomRSVP.section2_li_3") || "Undangan khusus: tanpa tambahan tamu"}</li>
              </ul>
              <p className="text-gray-700 text-[15px] md:text-[17px] leading-relaxed">
                {t("CustomRSVP.section2_footer") || "Fitur ini sangat membantu untuk menjaga kapasitas acara tetap terkendali."}
              </p>
            </div>

          </div>
        </div>
      </section>

      <section className="w-full bg-gray-50 py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-20">
            <div className="w-full md:w-[45%] flex justify-center">
              <div className="relative w-full max-w-[450px] aspect-[4/3] md:aspect-square">
                <Image 
                  src="/images/features/landing-page/fleksible-email.webp" 
                  alt="Kenapa fleksibel custom rsvp penting" 
                  fill 
                  className="object-contain drop-shadow-2xl md:scale-110" 
                />
              </div>
            </div>

            {/* Teks */}
            <div className="w-full md:w-[55%]">
              <h2 className="text-2xl md:text-3xl lg:text-[2.2rem] font-extrabold text-gray-900 mb-6 leading-tight tracking-tight">
                {t("CustomRSVP.section3_title") || "Kenapa fleksibel custom rsvp penting?"}
              </h2>
              
              <p className="text-gray-700 text-[15px] md:text-[17px] leading-relaxed mb-3">
                {t("CustomRSVP.section3_desc_1") || "Tanpa sistem RSVP yang terkontrol, sering terjadi:"}
              </p>
              <ul className="list-disc pl-5 space-y-2.5 text-gray-700 text-[15px] md:text-[17px] mb-6">
                <li>{t("CustomRSVP.section3_li_1") || "Jumlah tamu melebihi kapasitas"}</li>
                <li>{t("CustomRSVP.section3_li_2") || "Tamu datang membawa orang tambahan tanpa konfirmasi"}</li>
                <li>{t("CustomRSVP.section3_li_3") || "Data kehadiran sulit diprediksi"}</li>
              </ul>

              <p className="text-gray-700 text-[15px] md:text-[17px] leading-relaxed mb-3">
                {t("CustomRSVP.section3_desc_2") || "Dengan fleksibel Custom RSVP, kamu bisa:"}
              </p>
              <ul className="list-disc pl-5 space-y-2.5 text-gray-700 text-[15px] md:text-[17px]">
                <li>{t("CustomRSVP.section3_li_4") || "Menjaga kapasitas acara sesuai rencana"}</li>
                <li>{t("CustomRSVP.section3_li_5") || "Menghindari kehadiran berlebih"}</li>
                <li>{t("CustomRSVP.section3_li_6") || "Mengelola tamu dengan lebih rapi dan profesional"}</li>
              </ul>
            </div>

          </div>
        </div>
      </section>

      <section className="w-full bg-white py-16 md:py-24 border-y border-gray-100">
        <div className="max-w-6xl mx-auto px-4 md:px-8">
          <div className="flex flex-col md:flex-row-reverse items-center gap-12 lg:gap-20">
            <div className="w-full md:w-[45%] flex justify-center">
              <div className="relative w-full max-w-[350px] aspect-[4/3] md:aspect-square">
                <Image 
                  src="/images/features/landing-page/note.webp" 
                  alt="Cocok digunakan untuk" 
                  fill 
                  className="object-contain drop-shadow-xl" 
                />
              </div>
            </div>

            {/* Teks */}
            <div className="w-full md:w-[55%]">
              <h2 className="text-2xl md:text-3xl lg:text-[2.2rem] font-extrabold text-gray-900 mb-6 leading-tight tracking-tight">
                {t("CustomRSVP.section4_title") || "Cocok digunakan untuk"}
              </h2>
              <ul className="list-disc pl-5 space-y-3 text-gray-700 text-[15px] md:text-[17px]">
                <li>{t("CustomRSVP.section4_li_1") || "Intimate wedding dengan jumlah tamu terbatas"}</li>
                <li>{t("CustomRSVP.section4_li_2") || "Acara keluarga yang membutuhkan pembagian sesi"}</li>
                <li>{t("CustomRSVP.section4_li_3") || "Event profesional yang memerlukan kontrol akses"}</li>
                <li>{t("CustomRSVP.section4_li_4") || "Acara dengan kapasitas venue tertentu"}</li>
              </ul>
            </div>

          </div>
        </div>
      </section>

      <section className="w-full bg-gray-50 py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-20">
            <div className="w-full md:w-[45%] flex justify-center">
              <div className="relative w-full max-w-[450px] aspect-[4/3] md:aspect-[3/4]">
                <Image 
                  src="/images/features/landing-page/integrasi-feature.webp" 
                  alt="Terintegrasi dengan fitur lainnya" 
                  fill 
                  className="object-contain drop-shadow-2xl" 
                />
              </div>
            </div>

            {/* Teks */}
            <div className="w-full md:w-[55%]">
              <h2 className="text-2xl md:text-3xl lg:text-[2.2rem] font-extrabold text-gray-900 mb-6 leading-tight tracking-tight">
                {t("CustomRSVP.section5_title") || "Terintegrasi dengan fitur lainnya"}
              </h2>
              <p className="text-gray-700 text-[15px] md:text-[17px] leading-relaxed mb-4">
                {t("CustomRSVP.section5_desc") || "Fleksibel custom rsvp terhubung langsung dengan:"}
              </p>
              <ul className="list-disc pl-5 space-y-2.5 text-gray-700 text-[15px] md:text-[17px] mb-6">
                <li className='font-semibold'>{t("CustomRSVP.section5_li_1") || "Reminder acara otomatis"}</li>
                <li className='font-semibold'>{t("CustomRSVP.section5_li_2") || "Qr code check-in buku tamu"}</li>
                <li className='font-semibold'>{t("CustomRSVP.section5_li_3") || "Laporan data kehadiran tamu"}</li>
              </ul>
              <p className="text-gray-700 font-medium text-[15px] md:text-[17px] leading-relaxed">
                {t("CustomRSVP.section5_footer") || "Semua data rsvp digunakan untuk membantu acara berjalan lebih tertib."}
              </p>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
}